import {  FromObservable  } from '/druid/FromObservable';

export const from = FromObservable.create;